import dayjs from 'dayjs';
import { useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { backend } from '../axios/backend';
import DeleteModal from '../components/DeleteModal';
import DeleteMini from '../components/icons/DeleteMini';
import DocumentDuplicateOutline from '../components/icons/DocumentDuplicateOutline';
import PrettyLoader from '../components/PrettyLoader';
import Breadcrumbs from '../components/ui/Breadcrumbs';
import Button from '../components/ui/Button';
import IconButton from '../components/ui/IconButton';
import { config } from '../config';
import { useAppContext } from '../context/AppContext';

type Sharing = {
  sharedAt: Date;
  id: string;
  sharedWith?: {
    id: string;
    firstname: string;
    lastname: string;
  };
};

const ShareWishesPage = () => {
  const { user, alertSuccess } = useAppContext();
  const query = useQuery(['my-shares', user.username], async () => {
    const response = await backend.get<Sharing[]>('wish/shared/sharings');
    return response.data;
  });

  const [toDelete, setToDelete] = useState<Sharing | undefined>(undefined);

  const generateMutation = useMutation(async () => backend.post('wish/shared/generate'), {
    onSuccess: () => query.refetch(),
  });

  const deleteMutation = useMutation(async (sharedId: string) => backend.delete(`wish/shared/${sharedId}`), {
    onSuccess: () => {
      query.refetch();
      setToDelete(undefined);
    },
  });

  return (
    <div style={{ margin: '2rem' }}>
      <div className="space-y-3">
        <Breadcrumbs
          crumbs={[
            { text: 'Meine Wünsche', route: '/my-wishes' },
            { text: `Wünsche teilen`, route: `/share-wishes` },
          ]}
        />
        <h1 className="text-white text-xl">
          <b>Wünsche teilen</b>
        </h1>
        <p className="text-white">
          Hier kannst du einen Link zu deinen Wünschen generieren, welchen du dann mit deinen Freunden teilen kannst.
          Deine Freunde müssen sich dafür nicht einloggen.
        </p>
        <Button onClick={() => generateMutation.mutate()}>Neuen Link generieren</Button>
        <PrettyLoader useQueryResult={query}>
          <ul className="divide-y divide-gray-400 mb-4">
            {query.data?.map((sharing) => {
              const url = `${config.frontendUrl}/shared-wishes/${sharing.id}`;

              return (
                <li className="py-4" key={sharing.id}>
                  <div key={sharing.id} className="flex flex-row justify-between items-center">
                    <div className="flex flex-col">
                      <p className="text-white">{dayjs(sharing.sharedAt).format('DD.MM.YYYY HH:mm [Uhr]')}</p>
                      <p className="text-gray-400 text-sm">
                        {sharing.sharedWith ? `${sharing.sharedWith.firstname} ${sharing.sharedWith.lastname}` : url}
                      </p>
                    </div>
                    <div className="flex flex-row space-x-1">
                      {!sharing.sharedWith && (
                        <IconButton
                          Icon={DocumentDuplicateOutline}
                          onClick={() => {
                            navigator.clipboard.writeText(url);
                            alertSuccess('Link kopiert');
                          }}
                          variant="primary-muted"
                        />
                      )}
                      <IconButton Icon={DeleteMini} onClick={() => setToDelete(sharing)} variant="danger-muted" />
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </PrettyLoader>
      </div>
      <DeleteModal
        toDelete={toDelete}
        setToDelete={setToDelete}
        isLoading={deleteMutation.isLoading}
        onDelete={() => toDelete && deleteMutation.mutate(toDelete.id)}
        what={`die Teilung`}
      />
    </div>
  );
};

export default ShareWishesPage;
